import {
  isWebsiteBuilderElementFromBase,
  IWebsiteBuilderElementDataBase,
  TWebsiteBuilderElement,
  TWebsiteBuilderElementData,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderNodeBase } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderNode";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";

interface IGeneralTreeTraversalNode extends IWebsiteBuilderNodeBase {
  children?: IWebsiteBuilderNodeBase[];
}

type TElementTreeTraversalNode = TWebsiteBuilderElement | IGeneralTreeTraversalNode;
type TElementTreeTraversalUpdates = Partial<TWebsiteBuilderElementData>;

function applyUpdates<T extends IWebsiteBuilderElementDataBase>(element: T, updates: TElementTreeTraversalUpdates): T {
  return {
    ...element,
    ...updates,
  };
}

export function elementTreeTraversal(
  tree: IWebsiteBuilderRoot,
  id: string,
  updates: TElementTreeTraversalUpdates,
): IWebsiteBuilderRoot {
  function traverse(node: TElementTreeTraversalNode): TElementTreeTraversalNode {
    if (isWebsiteBuilderElementFromBase(node)) {
      if (node.id === id) {
        return {
          ...node,
          element: {
            ...applyUpdates(node.element, updates),
          },
        };
      } else {
        return node;
      }
    } else {
      if (!node.children) {
        return node;
      } else {
        return {
          ...node,
          children: node.children.map(child => traverse(child)),
        };
      }
    }
  }

  let updatedTree = traverse(tree) as IWebsiteBuilderRoot;

  updatedTree = {
    ...updatedTree,
    header: traverse(tree.header) as IWebsiteBuilderHeader,
    footer: traverse(tree.footer) as IWebsiteBuilderFooter,
  };

  return updatedTree;
}
